import React from "react";
import "./Page7.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto7 from "../images/pagePhoto7.png";
//-----------------------------------------

function Page7() {
  return (
    <div className="page7_container">
      <div className="page7_bangla">
        “Order Successful” এই মেসেজ' টি পাবার 7 সেকেন্ড পর এই Page টি নিজে থেকেই
        আবার প্রথম Page এ চলে আসবে। এই অর্ডারটি পরবর্তী পর্যায়ে E-Mail এর
        মাধ্যমে নিদ্দিষ্ট বিক্রেতার কাছে পৌঁছবে। প্রয়োজনে ক্রেতা তার নাম,
        Delivery Address এবং E-Mail দিতে পারেন।
      </div>
      <div className="page7_english">
        7 seconds after receiving the “Order Successful” message the page will
        be redirected to the first page automatically. This order will be
        received by the Seller through E-Mail in due course. If required the
        Buyer can also provide Name, Delivery Address & E-mail to the Seller.
      </div>
      <div className="page7_photo_div">
        <img className="page7_photo" src={pagePhoto7} alt="PagePhoto7 Logo" />
      </div>
      {/*--------------go to page-8 (next page) starts-------------*/}
      <NavLink to="/page8" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-8 (next page) ends-------------*/}
    </div>
  );
}

export default Page7;
